import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
//import madhyaImages from '../madhyaImages.json';
import { useSelector, useDispatch } from 'react-redux';
import { handlePageNumber } from '../redux/actions';

const TopNav = () => {
  const[madhyaImages, setMadhyaImages] = useState([]);
  const dispatch = useDispatch();
  const [menus, setMenus] = useState([]);
  const [distinctSubMenuItems, setDistinctSubMenuItems] = useState([]);
  // const [showOffcanvas, setShowOffcanvas] = useState(true); //control open/close menu
  const [showOffcanvas, setShowOffcanvas] = useState(false); //control open/close menu

  const[isOvered, setIsOvered] = useState(false);


useEffect(()=> {

  const openTimeout = setTimeout(() => {
    setShowOffcanvas(true); 
  }, 2500);

  const closeTimeout = setTimeout(() => {
    if (!isOvered) {
      setShowOffcanvas(false);
    }
  }, 7000); 

  return () => {
    clearTimeout(openTimeout);
    clearTimeout(closeTimeout);
  };

},[isOvered]);


  

  const pageArray = useSelector((state)=> state.allPagesNo);
  console.log("rrrrrrrrrxxxx",pageArray);
  console.log("last-number",pageArray[pageArray.length-1])


/*HHHHHHHHHH*/
  
// useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const response = await fetch("http://localhost:8000/api/frontend/get-all-data");
//       const data = await response.json();

//       // Filter to get only distinct titles
//       const seenTitles = new Set();
//       const distinctData = data.filter(item => {
//         if (!seenTitles.has(item.title)) {
//           seenTitles.add(item.title);
//           return true;
//         }
//         return false;
//       });

//       console.log("All Images first", distinctData);
//       setMadhyaImages(distinctData);
//       // Rebuild fullpage and trigger resize
//       setTimeout(() => {
//         window.dispatchEvent(new Event('resize'));
//         if (window.fullpage_api) window.fullpage_api.reBuild();
//       }, 300);

//     } catch (error) {
//       console.log("An error occurred:", error);
//     }
//   };

//   fetchData();
// }, []);

/*HHHHHHHHHH*/



//----DEKHTE HOBE

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await fetch("/api/frontend/get-all-projects");
      const data = await response.json();

      const seenTitleCategoryPairs = new Set();
      const filteredData = [];

      data.forEach(item => {
        item.categories.forEach(category => {
          const key = `${item.title}::${category}`;
          if (!seenTitleCategoryPairs.has(key)) {
            seenTitleCategoryPairs.add(key);
            filteredData.push(item);
          }
        });
      });

      setMadhyaImages(filteredData);

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
        if (window.fullpage_api) window.fullpage_api.reBuild();
      }, 300);

      console.log("Distinct Images by Category", filteredData);
    } catch (error) {
      console.log("An error occurred:", error);
    }
  };

  fetchData();
}, []);


  
  
  useEffect(() => {
    // Get distinct categories from madhyaImages
    const distinctCategories = [...new Set(madhyaImages.flatMap(obj => obj.categories))];
    setMenus(distinctCategories);

    // Find distinct sub-menu items (titles) across all categories
    const allSubMenuItems = madhyaImages.flatMap(img => img.title);
    const uniqueSubMenuItems = [...new Set(allSubMenuItems)];

    setDistinctSubMenuItems(uniqueSubMenuItems); // Set the distinct sub-menu items
    console.log('Distinct SubMenu Items:', uniqueSubMenuItems);
  }, [madhyaImages]);



  // Function to get titles related to the category
  const getSubMenuItems = (category) => {
    const relatedItems = madhyaImages
      .filter(img => img.categories.includes(category)) // Find images that belong to the category
      .map(img => img.title); // Extract their titles
    return relatedItems;
  };

 
  function funcSubMenuItems(item){
   console.log("LLLLLLL",item);
   console.log("MMMMMMM",distinctSubMenuItems);
   console.log("NNNNNN PAGE ARRAY: ",pageArray);
   for(let i in distinctSubMenuItems){
    if(distinctSubMenuItems[i]==item){
      console.log("ppppp",distinctSubMenuItems[i],i);
      for(let j in pageArray) {
        if(i==j){
          console.log("new",pageArray[j]);
          dispatch(handlePageNumber(pageArray[j]));
        }
      }
    }
   }
  }

  
  //____custom order____//
  const customOrder = ["Architectural", "Interior", "Furniture Design", "Landscape"];
  const sortedMenus = menus.sort((a, b) => customOrder.indexOf(a) - customOrder.indexOf(b));
  console.log(sortedMenus);


  // useEffect(()=>{
  //   setTotMobImages(useSelector(state=> state.totalMobImages))
  //   setTotDeskImages(useSelector(state=> state.totalDeskImages))
  // },[]);

  const totMobImages = useSelector(state => state.totalMobImages);
  const totDeskImages = useSelector(state => state.totalDeskImages);
  // console.log(mobFromStore,deskFromStore);



  return (
    <div className="position-fixed" style={{ zIndex: '5' }}>
      <Navbar key="false" expand="false" className="fixed-top">
        <Container fluid className="mx-2 mx-md-4 p-0">
          <Navbar.Brand href="#">
            {/* <img src={logo} alt="logo" className="img-fluid w-75" /> */}
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="offcanvasNavbar-expand-false"
            onClick={() => setShowOffcanvas(!showOffcanvas)} // Toggle offcanvas visibility
          />
          <Navbar.Offcanvas
          onMouseOver={() => setIsOvered(true)}
            id="offcanvasNavbar-expand-false"
            aria-labelledby="offcanvasNavbarLabel-expand-false"
            placement="end"
            show={showOffcanvas} // Controlled by the state
            onHide={() => setShowOffcanvas(false)} // Hide offcanvas when closed
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel-expand-false">
                {/* <img src={logo} alt="logo" className="img-fluid w-75" /> */}
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
            
              <Nav className="align-items-center justify-content-center flex-grow-1">
                <Nav className="justify-content-end flex-grow-1 pe-3 w-100">
                  <Nav.Link href="#action1" onMouseOver={() => setIsOvered(true)} onClick={() => {setShowOffcanvas(false); dispatch(handlePageNumber(3))}}>Ethos</Nav.Link>
                  <NavDropdown title="Portfolio" id={`offcanvasNavbarDropdown-expand-false`} onMouseOver={() => setIsOvered(true)}>
                    <ul>
                      {sortedMenus.map((menu, index) => {
                        return(
                            <li key={index}>
                              <NavDropdown title={menu} id={`offcanvasNavbarDropdown-expand-false`}>
                                {/* {menu} */}
                                <ul>
                                  {getSubMenuItems(menu).map((subMenuItem, subIndex) => (
                                    <li key={subIndex}>
                                      <NavDropdown.Item 
                                        className='subMenu'
                                        key={subIndex} 
                                        onClick={() => {
                                          funcSubMenuItems(subMenuItem); 
                                          setShowOffcanvas(false)
                                        }}
                                      >
                                        {subMenuItem}
                                      </NavDropdown.Item>
                                    </li>
                                  ))}
                                </ul>
                              </NavDropdown>
                            </li>
                          )
                      })}
                    </ul>
                  </NavDropdown>
                  {console.log("PAGE ARRAY IS GIVEN from TopNav:", pageArray,totDeskImages,totMobImages)}
                  <Nav.Link href="#action2" onMouseOver={() => setIsOvered(true)} onClick={() => {setShowOffcanvas(false); (window.innerWidth > 992)? dispatch(handlePageNumber(pageArray[pageArray.length-1]+totDeskImages+0)) : dispatch(handlePageNumber(pageArray[pageArray.length-1]+totMobImages+0))}}>Impact</Nav.Link>
                  <Nav.Link href="#action2" onMouseOver={() => setIsOvered(true)} onClick={() => {setShowOffcanvas(false); (window.innerWidth > 992)? dispatch(handlePageNumber(pageArray[pageArray.length-1]+totDeskImages+1)) : dispatch(handlePageNumber(pageArray[pageArray.length-1]+totMobImages+1))}}>Team</Nav.Link>
                  <Nav.Link href="#action2" onMouseOver={() => setIsOvered(true)} onClick={() => {setShowOffcanvas(false); (window.innerWidth > 992)? dispatch(handlePageNumber(pageArray[pageArray.length-1]+totDeskImages+2)) : dispatch(handlePageNumber(pageArray[pageArray.length-1]+totMobImages+2))}}>Contact</Nav.Link>
                </Nav>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
};

export default TopNav;
